export enum StatutTransaction {
    SOUMIS = 'soumis',
    TARITER = 'traité',
    CLOTURER = 'cloturé',
    TRAITEMENT = 'traitement',
}
